<script setup lang="ts">
const { siteOptions } = useSiteOptions();
const { cart, isLoading, status, error } = useCart();
</script>

<template>
  <div id="cart" class="space-y-8">
    <h1 class="h1 text-primary">
      {{ cart.cart_items.length ? "Votre panier" : "Votre panier est vide" }}
    </h1>
    <UiQueryWrapper :is-loading="isLoading" :status="status" :error="error">
      <template v-if="!cart.cart_items.length">
        <a :href="siteOptions.shop_url" class="btn-orange">Retourner à la boutique</a>
      </template>
      <template v-else>
        <div class="flex flex-col gap-8 lg:flex-row">
          <div class="space-y-8 lg:flex-[0_0_75%]">
            <CartGoals />
            <CartItems />
            <div class="flex flex-col gap-8 lg:flex-row">
              <CartConfirmation />
              <CartTotals class="flex-1">
                <template #totals>
                  <CartProceedToCheckout />
                </template>
              </CartTotals>
            </div>
          </div>
          <div class="flex flex-col gap-8">
            <CartSidebarShipping />
            <CartSidebarLillopoints />
            <CartSidebarCoupon />
          </div>
        </div>
      </template>
    </UiQueryWrapper>
  </div>
</template>
